import {AlterarProcesso} from "./alterar-processo";
import {DocumentoDetalhes} from "./documento-detalhes";
import {TarefaDetalhes} from "./tarefa-detalhes";
import {DetalhesAtendimento} from "../../cadastro/models/detalhes-atendimento";
import {MovimentacaoProcesso} from "./movimentacao-processo";

export class DetalhesProcesso extends AlterarProcesso{
  ultimaMovimentacao: Date;
  cliente: string;
  status: number;
  acao: number;
  responsavelNome: string;
  pastaNome:string;
  tipoAcaoNome?: string;
  totalDocumentos: number;
  totalTarefas: number;
  totalAtendimentos: number;

  documentos: DocumentoDetalhes[] = [];
  tarefas: TarefaDetalhes[] = [];
  atendimentos: DetalhesAtendimento[] = [];
  movimentacoes: MovimentacaoProcesso[] = [];
}
